// extracted by mini-css-extract-plugin
export default {"WellDialog":"Container_WellDialog__IE4Iq","InternalContainer":"Container_InternalContainer__EuY14"};